var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_2971)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41964 0.482422C8.79465 0.482422 9.16963 0.482422 9.54464 0.482422C11.5809 0.81316 12.9226 1.9616 13.57 3.92773C14.0283 5.86885 13.5303 7.51536 12.0759 8.86719C10.6214 10.0059 9.01596 10.2754 7.25948 9.67578C5.53211 8.94425 4.53016 7.64934 4.25362 5.79102C4.10312 3.75413 4.88243 2.18968 6.59151 1.09766C7.1686 0.782257 7.77797 0.577179 8.41964 0.482422Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.576 18.4821C11.5135 18.4821 6.45104 18.4821 1.38854 18.4821C1.24866 18.4183 1.14905 18.3128 1.08971 18.1657C1.05576 15.6613 2.04599 13.675 4.06041 12.2067C5.55522 11.2313 7.19586 10.8388 8.98229 11.029C12.0646 10.7684 14.4142 11.9403 16.0311 14.5446C16.6573 15.6718 16.9386 16.8788 16.8749 18.1657C16.8155 18.3128 16.7159 18.4183 16.576 18.4821Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_2971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.23a8477fb5035962b0f9a5fa5202645d.svg";
export { ForwardRef as ReactComponent };